import { Theme } from "@mui/material";

const ticketsStyles = (theme: Theme) => {
  return {
    textField: {
      fontSize: "16px",
      "& .MuiInputBase-input": {
        padding: "10px 8px",
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:hover:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:after": {
        borderBottom: "1px solid #7551D0 !important",
      },
    },
    headingText: {
      fontWeight: 600,
      fontSize: "14px",
      marginLeft: "5px",
    },
  };
};

export default ticketsStyles;
